import { QueryRuleFormType } from './components/query-rule-form/query-rule-configs/types';

export { QueryRuleFormType };

export enum QueryRuleArrayNameType {
  ALL = 'all',
  ANY = 'any',
  NOT = 'not'
}

export enum QueryRuleOperatorType {
  EQUAL = '=',
  GREATER_THAN = '>',
  LESS_THAN = '<',
  GREATER_THAN_EQUAL = '≥',
  LESS_THAN_EQUAL = '≤',
  NOT_EQUAL = '≠'
}

export const getOperatorsByType = (
  queryRuleArrayNameType: QueryRuleArrayNameType,
  queryRuleFormType: QueryRuleFormType | undefined
) => {
  switch (queryRuleFormType) {
    case QueryRuleFormType.DATE:
      return queryRuleArrayNameType === QueryRuleArrayNameType.NOT
        ? []
        : [
            QueryRuleOperatorType.LESS_THAN,
            QueryRuleOperatorType.LESS_THAN_EQUAL,
            QueryRuleOperatorType.EQUAL,
            QueryRuleOperatorType.GREATER_THAN_EQUAL,
            QueryRuleOperatorType.GREATER_THAN
          ];
    case QueryRuleFormType.SELECT:
      return queryRuleArrayNameType === QueryRuleArrayNameType.NOT
        ? [QueryRuleOperatorType.NOT_EQUAL]
        : [QueryRuleOperatorType.EQUAL];
    case QueryRuleFormType.TEXT:
    default:
      return queryRuleArrayNameType === QueryRuleArrayNameType.NOT
        ? [QueryRuleOperatorType.NOT_EQUAL]
        : [QueryRuleOperatorType.EQUAL];
  }
};
